import {
  Autocomplete,
  Box,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { getListUser } from "entities/report_revenue/service";
import React, { useEffect, useRef, useState } from "react";
import { useListData } from "hooks/useListData";

const SelectTeacher = ({
  callback,
  selectItem,
  customWidth,
}: {
  callback: (item: any) => void;
  selectItem: string;
  customWidth: string;
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [teachers, setTeachers] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const listboxRef = useRef<HTMLUListElement>(null);

  const fetchTeachers = async (search = "", newPage = 1, reset = false) => {
    if (!hasMore && !reset) return;

    setLoading(true);
    try {
      const response = await getListUser({
        limit: 10,
        page: newPage,
        user_role: "teacher",
        search,
      });

      if (reset) {
        setTeachers(response.data || []);
      } else {
        setTeachers((prev) => [...prev, ...response.data]);
      }

      if (response.data.length < 10) {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Lỗi khi lấy danh sách giáo viên:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchTeachers(searchTerm, 1, true);
  }, [searchTerm]);

  useEffect(() => {
    if (page > 1) {
      fetchTeachers(searchTerm, page);
    }
  }, [page]);

  const handleScroll = (event: React.SyntheticEvent) => {
    const listboxNode = listboxRef.current;
    if (!listboxNode) return;

    const { scrollTop, scrollHeight, clientHeight } = listboxNode;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <Box flex={1} mb={1} width={customWidth || "100%"}>
      <Typography variant="body1" fontWeight={550} mb={1}>
        Chọn giáo viên:
      </Typography>
      <Autocomplete
        value={selectItem ? teachers.find((t) => t._id === selectItem) : null}
        onChange={(event, newValue) => {
          if (!newValue) {
            setTeachers([]);
            callback("");
          } else {
            callback(newValue._id);
          }
        }}
        inputValue={searchTerm}
        onInputChange={(event, newInputValue) => {
          setSearchTerm(newInputValue);
        }}
        options={teachers}
        getOptionLabel={(option) => option.display_name || ""}
        loading={loading}
        ListboxProps={{
          ref: listboxRef,
          onScroll: handleScroll,
        }}
        onOpen={() => {
          if (teachers.length === 0) {
            fetchTeachers("", 1, true);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Tìm giáo viên"
            variant="outlined"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default SelectTeacher;
